/**
 * File lp-filled-track.js.
 * Track email capture fields being filled via Segment event
 */

function lpFilledTrackInit($) {
  const emailCaptureInput = $('.enroll-form .email-capture__input');

  function lpFilledTrack(input) {
    // find button location as hero, bottom, or communication based on button parents
    let btnLocation = (input.parents('.hero, .referral, .landing-page').length) ? 'hero' : 
                      (input.parents('.switch').length) ? 'bottom' : 
                      'communication';

    const email = input.first().val();
    if (!email) return;
    
    const properties = {
      button_location: btnLocation,
      email: email
    };

    // Pass landing page email filled message to tags.chime.com iframe
    firePostMessageEvent('tags.landing_page_email_filled');

    // trigger segment page event 'Landing Page Email Filled'
    segment(
      'track',
      'Landing Page Email Filled',
      properties,
      null,
      true
    );

    // Analytics SDK firing
    fireAnalyticsEvent(Track.WebFieldFilled, {
      unique_id: 'landing_page_email_filled',
      value: email,
      item_details: {
        "landing_page_email_filled": {
          "button_location": btnLocation,
        }
      }
    });
  }

  // init track event once on input
  emailCaptureInput.one('blur', function(){lpFilledTrack($(this))});
}